export async function fetchCNPJData(cnpj) {
  const url = `https://api.allorigins.win/get?url=${encodeURIComponent(`https://www.receitaws.com.br/v1/cnpj/${cnpj}`)}`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    // AllOrigins wraps the response in a "contents" property
    const json = JSON.parse(data.contents);

    return json;
  } catch (error) {
    console.error('Erro ao buscar CNPJ:', error);
    throw error;
  }
}
